import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';

import { AttackService } from '../attack/attack.service';
import { ClickOutsideDirective } from '../components/clickoutside.directive';
import { GaugeComponent } from '../components/gauge/gauge.component';
import { ProgressbarComponent } from '../components/progressbar/progressbar.component';
import { ModalService } from '../modals/modal.service';
import { ModalsModule } from '../modals/modals.module';
import { NotificationPanelComponent } from '../notifier/notification-panel.component';
import { NotifierService } from '../notifier/notifier.service';
import { PipesModule } from '../pipes/pipes.module';
import { ProgressModule } from '../progress/progress.module';
import { ConfigComponent } from './config/config.component';
import { DashboardComponent } from './dashboard.component';
import { DdosAttackConfigComponent } from './ddos-attack-config/ddos-attack-config.component';
import { DdosAttackResultsComponent } from './ddos-attack-results/ddos-attack-results.component';
import { HistoryComponent } from './history/history.component';
import { MainRoutingModule } from './main-routing.module';
import { TargetValidationDialog } from './target-validation/target-validation-dialog.component';
import { AdminConsentDialog } from './target-validation/admin-consent-dialog.component';
import { TargetValidationService } from './target-validation/target-validation.service';
import {ConfigService} from './config/config.service';
import {InputTrimDirective} from '../components/input-trim.directive';
import { ClipboardModule } from 'ngx-clipboard';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        RouterModule,
        ModalsModule,
        ProgressModule,
        MainRoutingModule,
        NgxDatatableModule,
        PipesModule,
        BrowserAnimationsModule,
        ClipboardModule
    ],

    declarations: [
        DashboardComponent,
        DdosAttackConfigComponent,
        ProgressbarComponent,
        ConfigComponent,
        HistoryComponent,
        DdosAttackResultsComponent,
        GaugeComponent,
        ClickOutsideDirective,
        NotificationPanelComponent,
        TargetValidationDialog,
        AdminConsentDialog,
        InputTrimDirective
    ],

    providers: [
        AttackService,
        TargetValidationService,
        ConfigService,
        NotifierService,
        ModalService
    ],

    exports: [
        DashboardComponent,
        ClickOutsideDirective,
        InputTrimDirective
    ],
})

export class MainModule { }



// WEBPACK FOOTER //
// ./src/app/main/main.module.ts